module.exports = __webpack_public_path__ + "img/HMXSBATplot-min.612756c4.png";